export const blockIconsCommonactionsUpdateNew = (
	<span className='material-symbols-outlined'>update</span>
);
